import { Alert, Box, Button, CircularProgress, TextField, Typography } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { requestCode } from "../services/authService";
import { validateEmail } from "../utils/emailUtil";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [inputError, setInputError] = useState("");
  const [isSending, setIsSending] = useState(false);
  const navigate = useNavigate();

  const handleEmailSubmit = async (e) => {
    e.preventDefault();
    if (isSending) return;
    if (!validateEmail(email)) {
      setInputError("Zadejte platnou e-mailovou adresu.");
      setEmail("");
      return;
    }
    setInputError("");
    setIsSending(true);
    try {
      const result = await requestCode(email, "forgot");
      if (result.success) {
        navigate("/verify-code", {
          state: { mode: "forgot", email },
        });
      } else {
        setInputError(result.message || "Ověřovací kód se nepodařilo odeslat.");
      }
    } finally {
      setIsSending(false);
    }
  };

  return (
    <Box sx={{ minWidth: "400px", maxWidth: "400px", margin: "10px auto" }}>
      <Typography
        variant="h6"
        sx={{
          fontSize: { xs: "1.2rem", sm: "1.5rem", md: "1.7rem" },
          mt: 4,
          mb: 2,
        }}
      >
        Obnova hesla
      </Typography>

      {/* Новая секция с дополнительной информацией */}
      <Alert severity="info" sx={{ mb: 3, lineHeight: 1.6 }}>
        Zadejte svůj e-mail, na který vám zašleme jednorázový ověřovací kód. Po
        jeho zadání budete moci nastavit nové heslo. Pokud e-mail nedorazí do 5
        minut, zkontrolujte složku Spam nebo zkuste odeslat kód znovu.
      </Alert>
      {inputError && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {inputError}
        </Alert>
      )}
      <Box component="form" onSubmit={handleEmailSubmit}>
        <TextField
          id="email"
          label="E-mail"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          disabled={isSending}
          fullWidth
          autoComplete="email"
          required
          sx={{ mb: 2 }}
        />
        <Button
          type="submit"
          variant="contained"
          disabled={isSending}
          startIcon={isSending ? <CircularProgress size={20} color="inherit" /> : undefined}
          sx={{ display: "block", m: "0 auto", width: "200px" }}
        >
          {isSending ? "Odesílám…" : "Pokračovat"}
        </Button>
        <Button
          variant="outlined"
          style={{ display: "block", margin: "5px auto", width: "200px" }}
          onClick={() => navigate("/login")}
        >
          Přihlásit se
        </Button>
      </Box>
    </Box>
  );
}
